import { type OrderStatus } from "@src/api";
import { i18n } from "@src/app/i18n";

const status_dictionary: Record<
  OrderStatus & "partial_picked" & "partial_complete",
  { label: string; variant: "primary" | "warning" | "success" | "error" }
> = {
  reserving: {
    label: i18n.global.t("Новый"),
    variant: "primary",
  },
  request: {
    label: i18n.global.t("Создан"),
    variant: "primary",
  },
  picking: {
    label: i18n.global.t("В работе"),
    variant: "warning",
  },
  picked: {
    label: i18n.global.t("Собран"),
    variant: "primary",
  },
  running: {
    label: i18n.global.t("Выносится"),
    variant: "success",
  },
  complete: {
    label: i18n.global.t("Выполнен"),
    variant: "success",
  },
  canceled: {
    label: i18n.global.t("Отменён"),
    variant: "error",
  },
  failed: {
    label: i18n.global.t("Сорван"),
    variant: "error",
  },
  expired: {
    label: i18n.global.t("Просрочен"),
    variant: "error",
  },
  partial_picked: {
    label: i18n.global.t("Собран частично"),
    variant: "primary",
  },
  partial_complete: {
    label: i18n.global.t("Выполнен частично"),
    variant: "success",
  },
  default: {
    label: i18n.global.t("Не найден"),
    variant: "primary",
  },
};

export const getStatus = (status: string, partial?: boolean) => {
  if (partial && status === "picked") return status_dictionary["partial_picked"];
  if (partial && status === "complete") return status_dictionary["partial_complete"];

  return status_dictionary[status] || status_dictionary["default"];
};
